export const customerRelations = {
  seo: {
    title: "Customer relations — Bespire AI assistant",
    description:
      "Win-back campaigns, follow-ups, review handling, complaint drafts. Bespire AI keeps caring for your customers.",
  },
  hero: {
    badge: "Customer relations",
    title: "So your customers don't forget you",
    subtitle:
      "Keeping a good customer is worth more than winning a new one. Bespire AI watches your customers, spots who's slipping away, knows when to say thanks or wish a happy birthday — and writes it for you.",
    ctaTrial: "Try it free for 3 days",
    ctaPricing: "See pricing →",
    customerCard: {
      label: "Customer profile · preview",
      name: "Petra Nagy",
      initials: "PN",
      subtitle: "Regular · 5 bookings",
      lastVisit: "Last visit",
      lastVisitValue: "4 months ago",
      favorite: "Favorite service",
      favoriteValue: "Evening yoga (60 min)",
      spent: "Total spent",
      spentValue: "€160",
      tags: ["Dormant", "Regular", "Evening slots"],
      suggestion: "AI suggestion",
      suggestionText: "3 message variants, all built around evening classes. The first one is waiting for approval.",
      action: "Send win-back message",
    },
  },
  journey: {
    title: "One customer's journey with Bespire",
    subtitle: "One customer, five touchpoints — Bespire knows what to say at each.",
    stages: [
      {
        icon: "UserPlus",
        time: "Day 1",
        title: "First booking",
        note: "Automatic confirmation, in your voice",
        message: "Hi Petra! Thanks for choosing us — you're booked for Thursday 6 pm. See you then!",
      },
      {
        icon: "MessageCircle",
        time: "+2 days",
        title: "Follow-up",
        note: "Thank-you + a satisfaction check",
        message: "Hi Petra! How did it feel yesterday? One word is enough — it helps a lot.",
      },
      {
        icon: "Star",
        time: "+3 days",
        title: "Review request",
        note: "Only if the follow-up was positive",
        message: "Glad it went well! If you have 1 minute, here's a link — it really helps others too.",
      },
      {
        icon: "Bell",
        time: "60 days later",
        title: "Quiet monitoring",
        note: "No message — just a note on your dashboard",
      },
      {
        icon: "PhoneCall",
        time: "4 months later",
        title: "Win-back campaign",
        note: "AI notices the drop-off",
        message: "Hi Petra! New evening classes just launched — right in your usual slots. 30% off your first session back.",
      },
      {
        icon: "Gift",
        time: "Birthday",
        title: "Small gesture",
        note: "Automatic, still human",
        message: "Happy birthday, Petra! 🎉 20% off any class until the end of the month.",
      },
    ],
  },
  segments: {
    title: "Bespire segments your customers for you",
    subtitle: "Not a static list — the AI recalculates continuously from bookings.",
    items: [
      {
        icon: "Sparkles",
        name: "New customers",
        count: "12 people",
        aiAction: "Onboarding series: thanks, tips, 2nd-booking discount",
        impact: "+35% return rate",
      },
      {
        icon: "Heart",
        name: "Active",
        count: "84 people",
        aiAction: "Monthly review request, upsell to service packages",
        impact: "+18% monthly revenue",
      },
      {
        icon: "Moon",
        name: "Dormant",
        count: "23 people",
        aiAction: "Personal win-back offer based on their favorite service",
        impact: "~30% come back",
      },
      {
        icon: "Crown",
        name: "VIPs",
        count: "9 people",
        aiAction: "Birthdays, early booking access, exclusive classes",
        impact: "3× average yearly value",
      },
    ],
  },
  templates: {
    title: "One AI — three channels, all in your voice",
    subtitle: "SMS, email, WhatsApp — never templated: Bespire uses the specific customer's history.",
    messages: [
      {
        channel: "WhatsApp",
        icon: "MessageCircle",
        sender: "Bella Studio",
        time: "18:04",
        text: "Hi Petra! 🌿 Just a reminder — Thursday 6 pm. If something comes up, one message and we'll move it — no problem.",
      },
      {
        channel: "Email",
        icon: "Mail",
        sender: "kata@recovery.co",
        time: "Today 09:12",
        subject: "Thanks for coming back",
        text: "Dear Zoltán, glad we met yesterday. Sending a 45-min premium package offer — only if it interests you, no pressure. Kata",
      },
      {
        channel: "SMS",
        icon: "Smartphone",
        sender: "+36 20 xxx xxxx",
        time: "10:32",
        text: "Happy birthday, Anna! 🎉 20% off any class until end of month. Book: bella.hu",
      },
    ],
  },
  reviews: {
    title: "Reviews — you approve, the AI replies",
    subtitle: "New Google review in? Bespire has a reply ready — in your voice, tuned to the actual feedback.",
    items: [
      {
        rating: 5,
        author: "Andrea T.",
        time: "2 days ago",
        text: "Kata's massage was a lifesaver after a long week. Silence, care, precision — exactly what she promised. Recommended!",
        replyTitle: "AI suggested reply",
        reply: "Thank you, Andrea! 🙏 So happy you got exactly what I promised — that's the best feedback I can get. See you next time!",
        replyStatus: "Waiting for approval",
      },
      {
        rating: 3,
        author: "Balázs K.",
        time: "5 days ago",
        text: "The massage itself was good, but I waited 15 minutes to check in and no one told me. I can't rate it higher.",
        replyTitle: "AI suggested reply",
        reply: "Balázs, thanks for the honest feedback. We're working on the wait time and I'd like to make it up — sending 15% off your next visit. Kata",
        replyStatus: "Waiting for approval",
      },
    ],
  },
  guardrail: {
    text: "Discounts and offers always stay within the limits you set — the AI never decides on your money on its own.",
  },
  crossLinks: {
    title: "Customer relations connects to everything",
    subtitle: "The same data lets Bespire write messages, launch campaigns, and flag anything worth attention.",
  },
  cta: {
    title: "Don't lose customers to forgetfulness",
    subtitle: "3-day free trial, no card required.",
    primary: "Try it free for 3 days",
    secondary: "See pricing",
  },
};
